export default __webpack_public_path__ + "static/payment-award-a7ea3fa256bec3fcd7d199f47fcbc6db.svg";